/*
 * Wrapper object around Segment's analytics global object.
 *
 * This is to hide the Segment implementation so we can change providers (or go directly against
 * Google Analytics) in the future if we choose to.
 *
 * NOTE: I tried to have a pointer to the global analytics object on this, but only the first couple
 * of calls worked. Then it was like each call just added to the list of pending calls or something.
 * I have a feeling it had something to do with assigning it to "this", like maybe it didn't like
 * not being called as a global?
 */
class AnalyticsWrapper {
  initialize (...args) {
    window.analytics.load(...args)
    window.analytics.debug(false)
  }

  reset () {
    window.analytics.reset()
  }

  identify (...args) {
    window.analytics.identify(...args)
  }

  page (...args) {
    window.analytics.page(...args)
  }

  track (...args) {
    window.analytics.track(...args)
  }
}

const Analytics = new AnalyticsWrapper()

/*
 * Function to register the current user (and their info) with Segment
 * TODO: Move this to redux?
 */
export function _registerUser (profile) {
  Analytics.identify(profile.user_id, {
    email: profile.email,
    nickname: profile.nickname,
    admin: profile.isAdmin,
    dieselInternal: profile.isDieselInternal,
    groups: profile.filteredGroups
  })
}

export default Analytics
